import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../tornado/utils/style';
import { SCREEN_WIDTH, SCREEN_HEIGHT } from '../tornado/utils/sizes';

const { screenSize, colorMode } = makeDefaultStylingContext();

export const OFFSET_BOTTOM = {
  [HD]: 64,
  [FULL_HD]: 88,
};

export const OFFSET_RIGHT = {
  [HD]: 64,
  [FULL_HD]: 88,
};

export const CONTENT_HEIGHT = {
  [HD]: 48,
  [FULL_HD]: 56,
};
export const TEXT_COLOR = makeThemeColor(PRIMARY)[colorMode];
export const CONTENT_WIDTH = (SCREEN_WIDTH[screenSize] - OFFSET_RIGHT[screenSize]) / 2;

export const getInfoBarOffsetX = () => SCREEN_WIDTH[screenSize] - OFFSET_RIGHT[screenSize];
export const getInfoBarOffsetY = () => SCREEN_HEIGHT[screenSize] - OFFSET_BOTTOM[screenSize];

export const getInitialStyle = () => ({
  x: getInfoBarOffsetX(),
  y: getInfoBarOffsetY(),
  w: 200,
  h: 60,
  mount: 1,
  flex: { direction: 'column', wrap: true, justifyContent: 'flex-end', alignContent: 'flex-end' },
  DeviceVersion: {
    text: {
      ...getFont(FONT.BERLIN_2, screenSize),
      textColor: TEXT_COLOR,
    },
  },
  AppVersion: {
    text: {
      ...getFont(FONT.BERLIN_2, screenSize),
      textColor: TEXT_COLOR,
    },
  },
});
